import { createBrowserRouter } from 'react-router-dom'

import { RequireAnon, RequireAuth } from '@/auth/guards'

/**
 * Guard'ы — pathless layout-роуты, а не проверка внутри каждой страницы: на новом экране защиту
 * тогда невозможно забыть, она уже надета ветвью маршрутов.
 */
export const router = createBrowserRouter([
  {
    Component: RequireAnon,
    children: [
      {
        path: '/login',
        lazy: async () => ({ Component: (await import('@/pages/LoginPage')).LoginPage }),
      },
      {
        path: '/register',
        lazy: async () => ({ Component: (await import('@/pages/RegisterPage')).RegisterPage }),
      },
      {
        path: '/recovery',
        lazy: async () => ({ Component: (await import('@/pages/RecoveryPage')).RecoveryPage }),
      },
    ],
  },
  {
    Component: RequireAuth,
    children: [
      {
        lazy: async () => ({ Component: (await import('@/components/AppLayout')).AppLayout }),
        children: [
          {
            index: true,
            lazy: async () => ({ Component: (await import('@/home/HomePage')).HomePage }),
          },
          {
            path: 'transactions',
            lazy: async () => ({
              Component: (await import('@/pages/TransactionsPage')).TransactionsPage,
            }),
          },
          {
            path: 'reports',
            lazy: async () => ({ Component: (await import('@/pages/ReportsPage')).ReportsPage }),
          },
          {
            path: 'more',
            lazy: async () => ({ Component: (await import('@/pages/MorePage')).MorePage }),
          },
          {
            path: 'accounts',
            lazy: async () => ({
              Component: (await import('@/pages/AccountsPage')).AccountsPage,
            }),
          },
          {
            path: 'reference',
            lazy: async () => ({
              Component: (await import('@/pages/ReferencePage')).ReferencePage,
            }),
          },
          {
            path: 'units',
            lazy: async () => ({
              Component: (await import('@/pages/UnitsPage')).UnitsPage,
            }),
          },
          {
            path: 'ledgers/new',
            lazy: async () => ({
              Component: (await import('@/pages/LedgerCreatePage')).LedgerCreatePage,
            }),
          },
          {
            path: 'reconcile',
            lazy: async () => ({
              Component: (await import('@/pages/ReconcilePage')).ReconcilePage,
            }),
          },
        ],
      },
    ],
  },
])
